import { Injectable } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationResult } from '../../shared/objects/enum/confirm-result';
import { NotificationService } from './notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationType } from '../../shared/enums/notification-type';

interface ConfirmationProps {
  titleKey: string;
  bodyKey: string;
  okButtonKey: string;
  cancelButtonKey: string;
  contextValue?: any;
  confirmAction(): void;
  dismissAction?(): void;
}

@Injectable()
export class ConfirmationDialogService {
  constructor(
    private translateService: TranslateService,
    private notificationService: NotificationService,
  ) {}

  setup(confirmationModalRef: NgbModalRef, props: ConfirmationProps): void {
    this.setupConfirmationModalProps(
      confirmationModalRef.componentInstance,
      props,
    );

    confirmationModalRef.componentInstance.optionChoosed.subscribe(
      (answer: ConfirmationResult) => {
        this.processConfirmationAnswer(answer, props);
      },
    );
  }

  private setupConfirmationModalProps(
    componentInstance: any,
    props: ConfirmationProps,
  ): void {
    this.translateService
      .get(props.titleKey)
      .subscribe(t => (componentInstance.title = t));
    this.translateService
      .get(props.okButtonKey)
      .subscribe(t => (componentInstance.confirmButtonText = t));
    this.translateService
      .get(props.cancelButtonKey)
      .subscribe(t => (componentInstance.declineButtonText = t));
    if (!!props.contextValue) {
      this.translateService
        .get(props.bodyKey, {
          value: props.contextValue,
        })
        .subscribe(t => (componentInstance.textToDisplay = t));
    } else {
      this.translateService
        .get(props.bodyKey)
        .subscribe(t => (componentInstance.textToDisplay = t));
    }
  }

  private processConfirmationAnswer(
    result: ConfirmationResult,
    props: ConfirmationProps,
  ): void {
    try {
      if (result === ConfirmationResult.Confirmed && props.confirmAction) {
        props.confirmAction();
      } else if (
        result === ConfirmationResult.Declined &&
        props.dismissAction
      ) {
        props.dismissAction();
      }
    } catch (response) {
      if (response instanceof HttpErrorResponse) {
        this.notificationService.show(NotificationType.ERROR, response.error);
      } else {
        this.notificationService.showRawError(response);
      }
    }
  }
}
